import Appsignal from '@appsignal/javascript';
import { version } from '../../package.json';

export const appsignal = new Appsignal({
  key: '0f956436-d43d-460a-b16f-ca5f1293eb09',
  revision: version,
});

export default {
  appsignal,
};
